export default "__VITE_PUBLIC_ASSET__d4902cf5__"